import CrashDetectionTable from './CrashDetectionTable'
import CrashDetectionLockedModal from '@/components/common/CrashDetectionLockedModal'
import { Container, Title } from './styles'

const CrashDetectionPage = () => {
  return (
    <Container>
      <Title>ตรวจจับการชน</Title>
      <CrashDetectionTable />
      <CrashDetectionLockedModal />
    </Container>
  )
}

export default CrashDetectionPage
